export default __webpack_public_path__ + "static/media/bin.b0d43c4e.svg";